import styled, {css, ThemeProvider} from "styled-components";

import {GlobalStyles, themes, themeTypes} from "../theme";
import {Notifications} from "./Notifications";
import {useLocalStorageState} from "../hooks/use-local-storage-state";
import Logo from "./Logo";
// import MainContent from "./MainContent";
// import SidebarNavigation from "./SidebarNavigation";

const ApplicationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 32px);
`;

const LogoContainer = styled.div(() => css`
  transition: opacity 0.3s;
  margin-top: -25px;

  &:hover {
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    display: none;
  }
`);

const SiteName = styled.h1`
  background-color: ${({theme}) => theme.colors.sidebar.siteNameBackground};
  border-radius: 3px;
  color: ${({theme}) => theme.colors.sidebar.siteName};
  font-family: ${({theme}) => theme.fonts.secondary};
  font-size: 13px;
  font-weight: normal;
  padding: 2px 8px;
  text-transform: uppercase;
  transition: background-color 0.2s, color 0.2s;
  margin-top: 15px;

  @media (min-width: 768px) {
    font-size: 13px;
    font-weight: bold;
  }
`;

const Subheading = styled.h4`
  color: ${({theme}) => theme.colors.grey[300]};
  font-family: ${({theme}) => theme.fonts.secondary};
  font-size: 10px;
  font-weight: normal;
  text-transform: uppercase;
  margin-top: 3px;
  transition: color 0.2s;

  @media (min-width: 768px) {
    font-size: 10px;
    font-weight: bold;
  }
`;

export const Application = () => {
  const {DARK} = themeTypes;
  const [selectedTheme] = useLocalStorageState('theme', DARK);

  // const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // const toggleTheme = () =>
  //   setSelectedTheme(selectedTheme === LIGHT ? DARK : LIGHT);

  return (
    <ThemeProvider theme={themes[selectedTheme]}>
      <GlobalStyles />
      <ApplicationContainer>
        <LogoContainer>
          <Logo size="medium" />
        </LogoContainer>

        <SiteName>Fernando Lujan</SiteName>
        <Subheading>Software &amp; Design</Subheading>
        {/* <SidebarNavigation
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
        <MainContent
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          selectedTheme={selectedTheme}
          toggleTheme={toggleTheme}
        /> */}
      </ApplicationContainer>
      <Notifications />
    </ThemeProvider>
  )
};

export default Application;
